import * as React from 'react';
import classnames from 'classnames';
import { getSelectionBoxStyles } from '@grandvisionhq/elements';

const SelectToggleButton = ({ children , isSelected , value , onClick , className  })=>{
    const handleClick = ()=>{
        onClick(value);
    };
    const classNames = getSelectionBoxStyles({
        isSelected,
        isDisabled: false,
        className
    });
    return /*#__PURE__*/ React.createElement("button", {
        className: classnames('select-toggle-button', classNames),
        onClick: handleClick,
        "aria-pressed": isSelected
    }, children);
};

export { SelectToggleButton };
//# sourceMappingURL=SelectToggleButton.js.map
